export * from './footer.component';
export * from './header.component';



// WEBPACK FOOTER //
// ./src/app/componentes/layout/index.ts